/* WegMug rd-design: header, hero-beats, manifest, reveal, mobiel menu, variantprijs */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  // Header: ondoorzichtig na scrollen (alleen op homepage transparant)
  const nav = document.querySelector('[data-rd-nav]');
  const isHome = nav && !nav.classList.contains('is-solid');

  // Hero met beats
  const heroes = [...document.querySelectorAll('[data-rd-hero]')];
  heroes.forEach((hero) => {
    const video = hero.querySelector('video');
    if (video && !reduce) {
      const show = () => video.classList.add('is-playing');
      video.addEventListener('playing', show, { once: true });
      if (!video.paused) show();
      video.play && video.play().catch(() => {});
    }
  });

  // Manifest: woorden lichten op
  const manifests = [...document.querySelectorAll('[data-rd-manifesto]')].map((el) => ({ el, words: [...el.querySelectorAll('.rd-w')] }));

  const onScroll = () => {
    const vh = window.innerHeight;
    if (nav && isHome) nav.classList.toggle('is-solid', window.scrollY > vh * 0.6);

    heroes.forEach((hero) => {
      const beats = [...hero.querySelectorAll('[data-rd-beat]')];
      if (beats.length < 2) return;
      const r = hero.getBoundingClientRect();
      const total = Math.max(1, hero.offsetHeight - vh);
      const p = clamp(-r.top / total, 0, 0.9999);
      const idx = Math.floor(p * beats.length);
      beats.forEach((b, i) => b.classList.toggle('is-on', i === idx));
    });

    manifests.forEach(({ el, words }) => {
      if (reduce) return;
      const r = el.getBoundingClientRect();
      const p = clamp((vh * 0.85 - r.top) / (r.height * 0.75), 0, 1);
      const lit = p * words.length;
      words.forEach((w, i) => w.style.setProperty('--lit', clamp(lit - i, 0, 1).toFixed(2)));
    });
  };

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { onScroll(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // Reveal
  const revealEls = document.querySelectorAll('[data-rd-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  // Mobiel menu
  const drawer = document.querySelector('[data-rd-drawer]');
  const openBtn = document.querySelector('[data-rd-menu-open]');
  if (drawer && openBtn) {
    const close = () => { drawer.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; openBtn.focus(); };
    openBtn.addEventListener('click', () => {
      drawer.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      drawer.querySelector('[data-rd-menu-close]')?.focus();
    });
    drawer.addEventListener('click', (e) => { if (e.target === drawer || e.target.closest('[data-rd-menu-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  // Variant-select → prijs bijwerken
  document.querySelectorAll('[data-rd-variant]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const price = sel.closest('form')?.querySelector('[data-rd-price]');
      const opt = sel.options[sel.selectedIndex];
      if (price && opt?.dataset.price) price.textContent = opt.dataset.price;
    });
  });
})();
